import * as React from 'react';

import styles from './activity-report-summary-table.module.css';

type ActivityTableQuotaHeaderProps = {
    quota: number;
    total: number;
    percent: number;
};

export const ActivityTableQuotaHeader = ({
    quota,
    total,
    percent,
}: ActivityTableQuotaHeaderProps) => {
    const quotaText = quota > 0 ? `${total} / ${quota}` : total;
    const percentDisplayNum = quota > 0 ? `${Math.round(percent * 100)}%` : '';

    return (
        <div className={styles['quota-cell-top']}>
            <div className={styles['quota-raw']}>{quotaText}</div>
            <div className={styles['quota-percent']}>{percentDisplayNum}</div>
        </div>
    );
};
